import axios from 'axios'
import { urls } from './urls'
import replaceParameters from '@/shahrzad-assets/shared-utils/replaceParameters'

export const signupOtp = ({
  nationalCode,
  mobileNo,
}: {
  mobileNo: string
  nationalCode: string
}) => {
  return axios.post(urls.SIGNUP_OTP, {
    nationalCode: nationalCode,
    mobileNo: mobileNo,
  })
}

export const signup = ({ body }: { body: any }) => {
  return axios.post(urls.SIGNUP, body)
}

export const signupLegalUser = (body: any) => {
  return axios.post(urls.SIGNUP_LEGAL_USER, body)
}

export const signupLegalUserVerify = (body: any) => {
  return axios.post(urls.SIGNUP_LEGAL_USER_VERIFY, body)
}

export const changeNumberOtp = ({
  nationalCode,
  newMobileNumber,
}: {
  nationalCode: string
  newMobileNumber: string
}) => {
  return axios.post(urls.CHANGE_NUMBER_OTP, {
    nationalCode: nationalCode,
    phoneNumber: newMobileNumber,
    userType: 1,
  })
}

export const changeNumber = ({
  otpCode,
  traceNo,
}: {
  otpCode: string
  traceNo: string
}) => {
  return axios.post(urls.CHANGE_NUMBER, {
    otpCode: otpCode,
    traceNo: traceNo,
  })
}

export const handshake = ({ tileId }: { tileId: number }) => {
  return axios.post(replaceParameters(urls.HANDSHAKE, { tileId: tileId }))
}

//payment
export const increaseAmount = ({ amount }: { amount: number }) => {
  return axios.post(urls.INCREASE_AMOUNT, { amount: amount })
}

export const transferAmount = ({ body }: { body: any }) => {
  return axios.post(urls.TRANSFER_AMOUNT, body)
}

//fava
export const campaign = () => {
  return axios.get(urls.CAMPAIGN)
}

export const applyShahrzadCode = (clubCode: string) => {
  return axios.post(urls.APPLY_SHAHRZAD_CODE, {
    clubCode,
  })
}

//gift scan
export const getGiftInfo = (i: number, t: number): Promise<number> => {
  return axios.get(urls.GET_GIFT_INFO, { params: { i: i, terminalId: t } })
}

export const getCardList = () => {
  return axios.get(urls.CARD_LIST)
}

//payment
export const payment = (data: any) => {
  return axios.post(urls.PAYMENT, { ...data })
}

export const ShopPayment = ({ body }: { body: any }) => {
  return axios.post(urls.SHOP_PAYMENT, body)
}

//about shahrzad
export const getAboutShahrzad = () => {
  return axios.get(urls.ABOUT_SHAHRZAD)
}

//faq
export const getFaqData = () => {
  return axios.get(urls.FAQ)
}

// wallet
export const deposit = () => {
  return axios.get(urls.DEPOSIT)
}

export const addDeposit = ({ iban }: { iban: string }) => {
  return axios.post(replaceParameters(urls.ADD_DEPOSIT, { iban: iban }))
}

export const purchase = ({ body }: { body: any }) => {
  return axios.post(urls.PURCHASE, body)
}

export const campaignTerminals = () => {
  return axios.get(urls.CAMPAIGN_TERMINALS)
}

export const getCashLaw = () => {
  return axios.get(urls.CASH_LAW)
}

export const getWalletBarcode = (body) => {
  return axios.post(urls.WALLET_BARCODE, body)
}

//support
export const getLevelFeatures = () => {
  return axios.get(urls.LEVEL_FEATURES)
}
export const cashOut = (body) => {
  return axios.post(urls.CASH_OUT, body)
}

export const getTerminals = () => {
  return axios.get(urls.TERMINALS)
}

export const getReferralCode = () => {
  return axios.get(urls.GET_REFERR_CODE)
}

export const getFestivalTickets = () => {
  return axios.get(urls.FESTIVAL_TICKETS)
}

export const setFestivalTicket = (code: string) => {
  return axios.post(replaceParameters(urls.SET_FESTIVAL_TICKET, { code: code }))
}

//support ticket

export const getSupportTicketCategory = () => {
  return axios.get(urls.SUPPORT_TICKETING_CATEGORY)
}

export const getSubCategory = ({ id }: { id: number }) => {
  return axios.get(
    replaceParameters(urls.SUPPORT_TICKETING_SUB_CATEGORY, {
      id: id,
    }),
  )
}

export const createTicket = (formdata: any) => {
  return axios.post(urls.CREATE_TICKET, formdata)
}

export const getSupportTicketList = (applicantId: string): Promise<string> => {
  return axios.get(urls.SUPPORT_TICKET_LIST, {
    params: { applicantId: applicantId },
  })
}

export const getFirstTicket = ({ id }: { id: number }) => {
  return axios.get(replaceParameters(urls.FIRST_USER_TICKET, { id: id }))
}

export const getMessage = ({ id }: { id: number }) => {
  return axios.get(replaceParameters(urls.GET_MESSAGE, { id: id }))
}

export const newMessage = (formdata: any) => {
  return axios.post(urls.NEW_MESSAGE, formdata)
}

export const getUserInfo = () => {
  return axios.get(urls.USER_INFO)
}
export const getUserQr = () => {
  return axios.get(urls.USER_QR)
}

export const getApplicatorGroups = (): Promise<any> => {
  return axios.get(urls.APPLICATOR_GROUPS)
}

export const getGroupsTitles = (): Promise<any> => {
  return axios.get(urls.GROUPS_TITLES)
}

export const getGroupMembers = ({
  groupId,
}: {
  groupId: number
}): Promise<any> => {
  return axios.get(replaceParameters(urls.GROUPS_MEMBERS, { groupId: groupId }))
}

export const getGroupRoles = ({ typeId }: { typeId: number }): Promise<any> => {
  return axios.get(replaceParameters(urls.GROUPS_ROLES, { typeId: typeId }))
}

export const createGroup = (groupData: any): Promise<any> => {
  return axios.post(urls.CREATE_GROUP, groupData)
}

export const createUser = (userData: any): Promise<any> => {
  return axios.post(urls.CREATE_USER, userData)
}

export const getUsersName = ({ aplicant }: { aplicant: string }) => {
  return axios.get(urls.GET_USERS_NAME, { params: { aplicant } })
}
export const getCentersList = () => {
  return axios.get(urls.CENTERS_LIST)
}

export const ReceiveMoney = ({ body }: { body: any }) => {
  return axios.post(urls.RECEIVE_MONEY, body)
}
